import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const arrowUp: ISVGPersonalProps = {
  viewBox: '0 0 10.033 5',
  content: (
    <path
      fill="currentColor"
      d="M 5.016 0 L 0 0.003 L 2.506 2.5 L 5.016 5 L 7.525 2.5 L 10.033 0.003 L 5.016 0 Z"
      transform="matrix(-1, 0, 0, -1, 10.033, 5)"
    />
  ),
};
